import React, { useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  Image,
  StyleSheet,
  Linking,
  Alert,
  Platform
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import Logo from "./assets/DaniLees_Logo.png";
// import { ToastContainer, toast } from "react-toastify";
import { authenticateUser } from "./apiCalls/LoginApi";
import { useDispatch } from "react-redux"
import { loginCreator } from "./slices/authSlice"
import Toast from "react-native-toast-message";


// Internal CSS for react-toastify
const toastifyCss = `
.Toastify__toast-container {
  z-index: 9999;
  font-family: sans-serif;
}
.Toastify__toast {
  border-radius: 4px;
  padding: 16px;
  font-size: 16px;
}
.Toastify__progress-bar {
  background: #A6CE39;
}
`;

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [errors, setErrors] = useState({});
  const navigation = useNavigation();
  const dispatch = useDispatch()

  const validateForm = () => {
    const newErrors = {};

    if (!email) newErrors.email = "Email is required";
    if (!password) newErrors.password = "Password is required";

    if (email && !/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email is invalid";
    }

    if (password && password.length < 6) {
      newErrors.password = "Password must be more than 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async () => {
    if (!validateForm()) {
      Toast.show({
        type: "error",
        text1: "Please correct the errors in the form.",
      })
      return;
    }



    // Set loginType based on checkbox state
    let loginType = isAdmin ? "admin" : "parent";
    console.log("this is the type we are passing", loginType);
    try {
      console.log(email, password, loginType);
      const response = await authenticateUser(email, password, loginType);
      //console.log("response is", response)
      if (response?.Success === 1) {
        Toast.show({
          type: "success",
          text1: "Login successful!",
        })

        dispatch(
          loginCreator({
            emailOrUserId: email,
            password: password,
            loginType: loginType
          })
        );
      } else {
        Toast.show({
          type: "error",
          text1: response?.Message || "Invalid email or password",
        })
      }
    } catch (error) {
      Toast.show({
        type: "error",
        text1: "Something went wrong. Please try again.",
      })
      console.error("Login error:", error);
    }
  };


  const handleForgotPassword = () => {
    Linking.openURL("https://admin.danileeshelpinghands.org/forget-password/1")
      .catch(err => console.error("Failed to open URL:", err));
  };

  const handleCreateAccount = () => {
    navigation.navigate("CreateAccount");
  };

  return (
    <View style={styles.container}>
      {Platform.OS === 'web' && <style>{toastifyCss}</style>}

      <View style={styles.header}>
        <Text style={styles.headerText}>Login</Text>
      </View>

      <View style={styles.content}>
        <Image source={Logo} style={styles.logo} resizeMode="contain" />

        <View style={styles.inputContainer}>
          <TextInput
            style={[styles.input, errors.email && styles.inputError]}
            placeholder="E-mail or User ID"
            placeholderTextColor="#505766"
            value={email}
            onChangeText={(text) => {
              setEmail(text);
              setErrors({ ...errors, email: null });
            }}
            keyboardType="email-address"
            autoCapitalize="none"
          />
          {errors.email && <Text style={styles.errorText}>{errors.email}</Text>}

          <TextInput
            style={[styles.input, errors.password && styles.inputError]}
            placeholder="Password"
            placeholderTextColor="#505766"
            value={password}
            onChangeText={(text) => {
              setPassword(text);
              setErrors({ ...errors, password: null });
            }}
            secureTextEntry
          />
          {errors.password && <Text style={styles.errorText}>{errors.password}</Text>}
          {
            (Platform.OS == 'web') ? (
              <TouchableOpacity style={styles.checkboxContainer} onPress={() => setIsAdmin(!isAdmin)} activeOpacity={0.8}>
                <View style={[styles.checkbox, isAdmin && styles.checkboxChecked]}>
                  {isAdmin && <Text style={styles.checkmark}>✓</Text>}
                </View>
                <Text style={styles.checkboxLabel}>Sign in as Admin</Text>
              </TouchableOpacity>
            ) : null
          }

          <TouchableOpacity onPress={handleForgotPassword}>
            <Text style={styles.forgotPassword}>Forgot Password</Text>
          </TouchableOpacity>

          <TouchableOpacity style={styles.loginButton} onPress={handleLogin}>
            <Text style={styles.loginButtonText}>Login</Text>
          </TouchableOpacity>

          <TouchableOpacity style={styles.createAccountButton} onPress={handleCreateAccount}>
            <Text style={styles.createAccountText}>Create Account</Text>
          </TouchableOpacity>
        </View>
      </View>

      {/* <ToastContainer position="top-center" autoClose={3000} /> */}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  header: {
    backgroundColor: "#A6CE39",
    padding: 15,
    alignItems: "center",
  },
  headerText: {
    color: "#fff",
    fontSize: 25,
    fontWeight: "bold",
  },
  content: {
    flex: 1,
    alignItems: "center",
    padding: 20,
  },
  logo: {
    width: 200,
    height: 125,
    marginVertical: 30,
  },
  inputContainer: {
    width: "95%",
    marginTop: 20,
  },
  input: {
    borderWidth: 1,
    borderColor: "#505766",
    color: '#000',
    borderRadius: 4,
    padding: 15,
    marginBottom: 15,
    width: "100%",
    height: 55,
    fontSize: 18,
  },
  inputError: {
    borderColor: "red",
  },
  checkboxContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 5,
    marginBottom: 15,
  },
  checkbox: {
    width: 22,
    height: 22,
    borderWidth: 1.5,
    borderColor: "#505766",
    borderRadius: 5,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 10,
    backgroundColor: "#fff",
  },
  checkboxChecked: {
    backgroundColor: "#A6CE39",
    borderColor: "#A6CE39",
  },
  checkmark: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "bold",
  },
  checkboxLabel: {
    fontSize: 16,
    color: "#505766",
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
  },
  errorText: {
    color: "red",
    fontSize: 14,
    marginBottom: 10,
  },
  forgotPassword: {
    color: "#666",
    textAlign: "center",
    marginVertical: 15,
    fontSize: 16,
  },
  loginButton: {
    backgroundColor: "#A6CE39",
    padding: 10,
    marginTop: 10,
    alignSelf: "center",
    width: 160,
    borderRadius: 10,
  },
  loginButtonText: {
    fontWeight: "bold",
    color: "#fff",
    textAlign: "center",
    fontSize: 24,
  },
  createAccountButton: {
    marginTop: 15,
  },
  createAccountText: {
    fontWeight: "bold",
    color: "#000",
    textAlign: "center",
    fontSize: 18,
    marginTop: 10,
  },
});
